<template>
<div class="chapter">
<div class="inner_page">
<h2 id="Epigraph" title="Epigraph"></h2>
<p class="epigraph">“The tops of mountains are among the unfinished parts of the globe, whither it is a slight insult to the gods to climb and pry into their secrets, and try their effect on our humanity. Only daring and insolent men, perchance, go there.”</p>
<p class="epigraphbyline">—Henry David Thoreau</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?6f96e87b